<ion-content class="ion-text-center">
  <div class="center">
    <ion-icon name="lock-closed-outline" class="center__icon"></ion-icon>
    <h1>{{ 'access.title' | translate }}</h1>
    <p>{{ 'access.message' | translate }}</p>
    <div class="center__actions">
      <ion-button routerLink="/tokens">{{ 'common.retry' | translate }}</ion-button>
      <ion-button fill="clear" (click)="auth.logout()">{{ 'common.logout' | translate }}</ion-button>
    </div>
  </div>
</ion-content>
